/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { GlobalService } from './services/global.service';
import { ContactService } from './services/contact.service';
import { ContactProfileService } from './services/contact-profile.service';
import { CompanyService } from './services/company.service';
import { StackCompanyService } from './services/stack-company.service';
import { TechStackService } from './services/tech-stack.service';
import { StatisticsService } from './services/statistics.service';
import { SuggestService } from './services/suggest.service';
import { SavedSearchService } from './services/saved-search.service';
import { InternalService } from './services/internal.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    GlobalService,
    ContactService,
    ContactProfileService,
    CompanyService,
    StackCompanyService,
    TechStackService,
    StatisticsService,
    SuggestService,
    SavedSearchService,
    InternalService,
    ApiConfiguration
  ],
})
export class SearchApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<SearchApiModule> {
    return {
      ngModule: SearchApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: SearchApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('SearchApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
